<template>
  <div class="expert-score">
    <div class="container-fluid">
      <div class="wrapper">
        <div class="content-page">
          <div class="content">
            <div class="row mb-1">
              <div class="col-xl-6">已立项课题</div>
              <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
                <Breadcrumb></Breadcrumb>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
								<template v-if="!isShowDetail">
									<div class="mb-3">
									  <el-input class="mr-2 mb-1" v-model="query.declareName" placeholder="请输入课题名称" size="small" style="width: 180px"></el-input>
									  <el-cascader class="mr-2 mb-1" :options="areaOptions" :props="{ expandTrigger: 'hover',  checkStrictly: true, label: 'name', value: 'id' }" placeholder="-请选择所属区域-" clearable filterable size="small" @change="cascaderChange">
									    <template slot-scope="{ node, data }">
									      <span>{{ data.name }}</span>
									      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
									    </template>
									  </el-cascader>
									  <el-select class="mr-2 mb-1" v-model="query.learningType" placeholder="-请选择所属学段-" clearable size="small">
									    <el-option v-for="item in stageOptions" :key="item.id" :label="item.name" :value="item.id">
									    </el-option>
									  </el-select>
									  <el-cascader class="mr-2 mb-1" :options="subjectTypeOptions" :props="{ expandTrigger: 'hover', label: 'name', value: 'id' }" placeholder="-课题类别-" clearable filterable size="small" @change="cascaderSubjectTypeChange">
									    <template slot-scope="{ node, data }">
									      <span>{{ data.name }}</span>
									      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
									    </template>
									  </el-cascader>
									  <el-button class="ml-2 mb-1" type="success" size="small" @click="searchData">查询</el-button>
									</div>
									<div class="mb-2" style="text-align:right">
									  <!-- <el-button class="mb-1" type="primary" icon="el-icon-upload" size="small" @click="exportExcel">导出Excel</el-button> -->
									  <!-- <el-button class="mb-1" type="primary" icon="el-icon-upload" size="small" @click="getProjectWord1">导出立项通知</el-button> -->
									</div>
									<el-table id='exportTab' :header-cell-style="tableHeaderStyle" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%;margin-bottom: 20px;" border>
									  <el-table-column prop="id" label="序号" min-width="40"></el-table-column>
									  <el-table-column prop="projectNumber" label="立项编号" min-width="100"></el-table-column>
									  <el-table-column prop="declareName" label="课题名称" min-width="120">
											<template v-slot="scope">
												<div style="color: deepskyblue;cursor: pointer;" @click="viewTopicDetail(scope.row)">{{scope.row.declareName}}</div>
											</template>
										</el-table-column>
									  <el-table-column prop="projectTypeName" label="课题类别" sortable min-width="90"></el-table-column>
									  <el-table-column prop="learningTypeName" label="所属学段" sortable min-width="90"></el-table-column>
									  <el-table-column prop="disciplineName" label="学科分类" sortable min-width="90"></el-table-column>
									  <el-table-column prop="oneUnitName" label="单位" sortable min-width="80"></el-table-column>
									  <el-table-column prop="oneEmceeName" label="负责人" sortable min-width="80"></el-table-column>
									  <el-table-column prop="expectedClosingTime" label="预结题时间" min-width="110">
											<template v-slot="scope">
												{{scope.row.expectedClosingTime | getTime}}
											</template>
										</el-table-column>
									  <el-table-column prop="coreMember" label="课题组成员" min-width="120">
											<template v-slot="scope">
												{{scope.row.coreMember|getCoreMember}}
											</template>
										</el-table-column>
									</el-table>
									<el-button type="primary" icon="el-icon-upload" @click="exportExcel">导出Excel</el-button>
									<!-- 分页器 -->
									<div class="text-right mt-2">
									  <el-pagination layout="total, sizes, prev, pager, next, jumper" background :current-page="query.pageNumber" :page-sizes="[10, 50, 100, 200]" :page-size="query.pageSize" :total="total" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
									</div>
								</template>
                
								<TopicReviewDetail @goback="isShowDetail=false" :topicInfo="topicInfo" v-else/>
								
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAreaTree,
  getPlatformInformationData,
} from "@/api/after/systemManagement";
import { getProjectList, getProjectWord } from "@/api/after/proposedProject";
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
import { TopicDeclarationDetail } from '@/api/after/schoolAudit.js';
import TopicReviewDetail from '../components/TopicReviewDetail.vue'
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "approvedProject",
  components: {
    Breadcrumb,
		TopicReviewDetail
  },
  data() {
    return {
      tableHeaderStyle: {
        backgroundColor: "#3083c5",
        color: "#fff",
      },
      tableSort: {
        prop: "projectTypeName",
        prop: "learningTypeName",
        prop: "disciplineName",
        prop: "unitName",
        prop: "oneEmceeName",
        prop: "internNumber",
        prop: "internResults",
      },
      areaOptions: [], //区域列表
      subjectTypeOptions: [], //课题类别
      //学段列表
      stageOptions: [
        { id: "0", name: "幼儿园" },
        { id: "1", name: "小学" },
        { id: "2", name: "初中" },
        { id: "3", name: "高中" },
        { id: "4", name: "中/高职" },
        { id: "5", name: "其他" },
      ],

      query: {
        declareName: "", //课题名称
        learningType: null, //学段
        regionId: null, //区域id
        projectTypeId: null, //课题类别id
        pageNumber: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      multipleSelection: [], //被选中的项
      queryUpdate: { id: [], type: 1 },
			topicInfo:{},
			isShowDetail:false,
    };
  },
	filters:{
		// 获取课题组成员
		getCoreMember(val){
			if (val) {
				return val.replace(/,/g,'、')
			}else{
				return ''
			}
		}
	},
  mounted() {
    this.getData();
    this.getAreaTree();
    this.getPlatformInformationData();
  },
  methods: {
		// 课题申报详情
		async TopicDeclarationDetail(id){
			const res = await TopicDeclarationDetail(id)
			if (res.code == 200) {
				console.log('详情',res);
				this.topicInfo = res.data
				// this.$nextTick(()=>{
				// 	// 数据请求成功之后渲染pdf
				// 	if (Object.keys(this.topicInfo).length) {
				// 		this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
				// 	}
				// })
			}else{
				this.$message.error(res.data)
			}
		},
		// 点击课题名称查看详情
		async viewTopicDetail(data){
			await this.TopicDeclarationDetail(data.declareId)
			this.isShowDetail = true
		},
    // 获取数据列表
    getData(isNum) {
      if (isNum) this.query.pageNumber = 1;
      getProjectList(this.query).then((res) => {
        if (res.code == 200) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 获取区域树
    getAreaTree() {
      getAreaTree().then((res) => {
        if (res.code == 200) {
          this.areaOptions = res.data;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 获取课题类别
    getPlatformInformationData() {
      getPlatformInformationData(1).then((res) => {
        if (res.code == 200) {
          this.subjectTypeOptions = res.data;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 搜索
    searchData() {
      this.getData(true);
    },
    //区域筛选
    cascaderChange(e) {
      let num = null;
      e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
      this.query.regionId = num;
    },
    //课题类别筛选
    cascaderSubjectTypeChange(e) {
      let num = null;
      e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
      this.query.projectTypeId = num;
    },
    // 导出表格
    exportExcel() {
      var xlsxParam = { raw: true };
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#exportTab"),
        xlsxParam
      );
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "已立项课题表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") {
          console.log(e, wbout);
        }
      }
      return wbout;
    },
    getProjectWord1() {
      const link = document.createElement("a");
      getProjectWord().then((res) => {
        let blob = new Blob([res], { type: "application/msword" });
        let objectUrl = URL.createObjectURL(blob); // 创建URL
        link.href = objectUrl;
        link.download = "立项通知.doc"; // 自定义文件名
        link.click(); // 下载文件
        URL.revokeObjectURL(objectUrl); // 释放内存
      });
    },

    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getData(true);
    },
  },
};
</script>

<style scoped>
.file_box {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px dashed #d9d9d9;
  height: 30px;
  padding: 0 20px;
  cursor: pointer;
  max-width: calc(100% - 150px);
  margin: 5px 0;
}
.file_box p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 450px;
  margin-bottom: 0;
  line-height: normal;
}
.close_btn {
  position: absolute;
  top: -8px;
  right: -8px;
}
.wrap {
  background: #fafbfe;
  padding: 30px;
}
.con {
  min-height: 500px;
  background: #fff;
  padding: 30px;
  border-radius: 5px;
}
/deep/.el-table th > .cell {
  text-align: center;
}

/deep/.el-table .cell {
  text-align: center;
}
</style>